import axios from 'axios'
import { BASE_URL } from '@/api/config'
import { removeToken, setTokenTime } from '@/common/auth'
import miment from 'miment'

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 15000
})

service.interceptors.response.use(
  response => {
    setTokenTime(miment().format('YYYY-MM-DD hh:mm:ss'))
    const res = response.data
    if (res.d) {
      const ret = JSON.parse(res.d)
      if (ret.errCode === 40001) {
        // tokenå¤±æ•ˆ
        removeToken()
        location.reload()
      }
      if (ret.errCode === -1) {
        // tokenå¤±æ•ˆ
        removeToken()
        // location.reload()
      }
      // set response.data = JSON.parse(response.data.d)
      response.data = ret
    }
    if (res.errCode === 40001) {
      // tokenå¤±æ•ˆ
      removeToken()
      location.reload()
    }
    if (res.errCode === -1) {
      // tokenå¤±æ•ˆ
      removeToken()
      // location.reload()
    }
    return response
  },
  error => {
    // eslint-disable-next-line
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/common/request.js